module.exports = __webpack_public_path__ + "img/wtBack.12840b28.png";